import { PureComponent } from 'react'
import { Provider } from 'react-redux'
import { getDefaultStore } from 'shared/redux/init-store'
import Header from './header'
import withStorageContextProvider from 'react-storage-context'

const store = getDefaultStore({})

@withStorageContextProvider('giphy-desktop')
class HeaderEntry extends PureComponent {
    render() {
        return (
            <Provider store={store}>
                <Header {...this.props} />
            </Provider>
        )
    }
}

export default HeaderEntry
